export const GROUP_ONLY_PERMANENT_TYPE_VALUE = 'PERMANENT';
export const GROUP_ONLY_TEMPORARY_TYPE_VALUE = 'TEMPORARY';
